import * as React from 'react';
import { match as Match } from 'react-router';
import { ConfigurationDetailPage } from './ConfigurationDetail';
import ConfigurationNew from './ConfigurationNew/ConfigurationNew';

import { connect } from 'react-redux';

import './Configuration.page.scss';

export interface ConfigurationPageProps {
  dispatch: Function;
  match: Match<{configurationId: string}>;
}

export interface ConfigurationPageState {
  didMount: boolean;
}

export class ConfigurationPagePartial extends React.Component<ConfigurationPageProps, ConfigurationPageState> {

  constructor(props: ConfigurationPageProps) {
    super(props);
    this.state = {
      didMount: false,
    };
  }

  componentDidMount() {
    this.setState({didMount: true});
  }

  public render() {
    return this.state.didMount ? (
      <div className="page-configurations">
        {this.hasConfigurationId && this.configurationId && (
          <>
            {this.configurationId === 'new' ? (
              <ConfigurationNew />
            ) : (
              <ConfigurationDetailPage configurationId={this.configurationId} />
            )}
          </>
        )}
      </div>
    ) : null;
  }

  private get configurationId(): string | undefined {
    const { match } = this.props;
    return match && match.params && match.params.configurationId;
  }

  private get hasConfigurationId(): boolean {
    return this.configurationId ? true : false;
  }
}

export const ConfigurationPage = connect()(ConfigurationPagePartial);

export default ConfigurationPage;